import { useState } from 'react';
import { isIos, useInstallStore } from '@/lib/install';
import { usePreferences } from '@/stores/preferences';
import { Button, Sheet, Icon } from '@/components/ui';

const SNOOZE_MS = 14 * 86_400_000;

/** Bannière d'installation personnalisée (Android : beforeinstallprompt, iOS : guide). */
export function InstallBanner() {
  const { deferred, installed, promptInstall } = useInstallStore();
  const { installDismissedAt, dismissInstall } = usePreferences();
  const [iosGuide, setIosGuide] = useState(false);
  const ios = isIos();

  if (installed || Date.now() - installDismissedAt < SNOOZE_MS) return null;
  if (!deferred && !ios) return null;

  return (
    <>
      <aside aria-label="Installer l'application" className="fixed inset-x-0 bottom-[calc(72px+env(safe-area-inset-bottom))] z-30 mx-auto max-w-lg px-4">
        <div className="flex items-center gap-3 rounded-2xl bg-white p-3 shadow-xl ring-1 ring-brand-100">
          <img src="/icons/icon-192.png" alt="" className="h-12 w-12 rounded-xl" width={48} height={48} />
          <div className="flex-1">
            <p className="font-semibold text-brand-900">Installer Zakat Layène</p>
            <p className="text-xs text-gray-600">Accès rapide, hors ligne, moins de data.</p>
          </div>
          <Button size="sm" onClick={() => (ios ? setIosGuide(true) : void promptInstall())}>
            Installer
          </Button>
          <button onClick={dismissInstall} className="flex h-10 w-10 items-center justify-center text-gray-400" aria-label="Plus tard">
            <Icon name="close" size={18} />
          </button>
        </div>
      </aside>
      <Sheet open={iosGuide} onOpenChange={setIosGuide} title="Installer sur iPhone" description="Trois gestes dans Safari :">
        <ol className="space-y-4 text-gray-800">
          <li className="flex gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-800 font-bold text-white">1</span>
            <span>
              Touchez le bouton <strong>Partager</strong>{' '}
              <svg viewBox="0 0 24 24" className="inline h-5 w-5 align-text-bottom text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" aria-label="(icône carré avec flèche)">
                <path d="M12 3v12M8 7l4-4 4 4M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
              </svg>{' '}
              en bas de l’écran.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-800 font-bold text-white">2</span>
            <span>
              Faites défiler et choisissez <strong>« Sur l’écran d’accueil »</strong>.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-800 font-bold text-white">3</span>
            <span>
              Touchez <strong>Ajouter</strong>. L’icône Zakat Layène apparaît comme une application.
            </span>
          </li>
        </ol>
        <Button block className="mt-6" onClick={() => setIosGuide(false)}>
          J’ai compris
        </Button>
      </Sheet>
    </>
  );
}
